/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { compose } from 'redux';
import { object, string } from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import NearMeIcon from '@material-ui/icons/NearMe';
import { Alert } from '@material-ui/lab';
import { Snackbar } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import * as app from '../../../../../state/ducks/App';
import customBreakpoints from '../../../../helpers/customBreakpoints';
import emailSubscriptionAPI from '../helper/PlantsFooterHelper';
import { getAccessToken  } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const brandSelectors = app.ducks.brand.selectors;

const styles = (theme) => ({
    subscription: {
        maxWidth: '305px',
        margin: '0 auto',
        marginRight: 0,
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            maxWidth: '340px',
            margin: '25px auto',

        },
        '& .subscription-form': {
            display: 'flex',
            '&>div': {
                flex: '0 1 100%',
                '&>div': {
                    borderRadius: 0,
                    border: '1px solid #707070',
                },
            },
            '& input': {
                height: '40px',
                padding: theme.spacing(0, 1),
                fontFamily: 'Hind,sans-serif',
                fontSize: '14px',
            },
            '& fieldset': {
                border: '0',
            },
        },
        '& .plaSubscription-form': {
            display: 'flex',
            marginLeft: 'auto',
            marginRight: 'auto',
            [theme.breakpoints.down(theme.breakpoints.maxWidth.screen_ipad_11)]: {
                width: '215px',
            },
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                width: '305px',
            },
            '&>div': {
                flex: '0 1 100%',
                '&>div': {
                    borderRadius: 0,
                    border: '1px solid #707070',
                },
            },
            '& input': {
                height: '40px',
                padding: theme.spacing(0, 1),
                fontFamily: 'Hind, sans-serif',
                fontSize: '14px',
            },
            '& fieldset': {
                border: '0',
            },
        },
        '& button': {
            height: '40px',
            width: '40px !important',
            minWidth: '40px !important',
            marginLeft: '10px',
            borderRadius: '0',
            backgroundColor: theme.palette.black,
            '& svg': {
                fill: theme.palette.white,
            },
            '&:hover': {
                backgroundColor: theme.palette.black,
            },
        },
        '& p': {
            color: theme.palette.black,
            fontSize: '0.6875rem',
            lineHeight: '1.5',
            paddingTop: 7,
            textAlign: 'center',
            margin: 0,
            '&.plaBlock': {
                paddingTop: 0,
                display: 'block',
                '& a': {
                    color: theme.palette.black,
                },
            },
            '&.block': {
                display: 'block',
                '& a': {
                    color: theme.palette.black,
                },
            },
        },
    },
});

const Subscription = ({ classes, jwt }) => {
    const [show_message, setShowMessage] = useState();
    const [message, setMessage] = useState();
    const [email, setEmail] = useState();
    const [severity, setSeverity] = useState();

    const dispatch = useDispatch();

    const brand = useSelector(brandSelectors.getBrand);

    const handleEventClick = (label) => {
        dispatch(trackEvent({
            eventCategory: 'Global Footer',
            eventAction: 'Click',
            eventLabel: label,
            eventName: 'feature_interaction',
        }));
    };

    const handleClick = async (e) => {
        e.preventDefault();
        handleEventClick('Email Subscription');
        if (email && email.match(/^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)) {
            const payload = {
                email,
            };
            const apiResponse = await emailSubscriptionAPI(jwt, payload);

            if (apiResponse?.code !== 200) {
                setMessage(apiResponse?.message);
                setSeverity('error');
                setShowMessage(true);
                setEmail('');
            } else {
                setMessage(apiResponse?.message);
                setSeverity('success');
                setShowMessage(true);
            }
        } else {
            setMessage('Invalid Email Address');
            setSeverity('error');
            setShowMessage(true);
        }
    };
    const handleFieldChange = (event) => {
        const fieldValue = event?.target?.value;
        setEmail(fieldValue);
    };
    return (
        <div className={classes.subscription}>
            <form className={brand?.code === 'PLA' ? 'plaSubscription-form' : 'subscription-form'}>
                <TextField
                    className="text-field-wrapper"
                    variant="outlined"
                    title="Enter your email to sign up for new plant updates, special deals, care tips and more!"
                    placeholder="Email"
                    value={email}
                    onChange={handleFieldChange}
                />
                <Snackbar onClose={() => { setShowMessage(false); }} open={show_message} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <Alert severity={severity} sx={{ width: '100%' }}>
                        {message}
                    </Alert>
                </Snackbar>
                <Button type="submit" variant="contained" onClick={handleClick}><NearMeIcon /></Button>
            </form>
            <p>Sign up for new plant updates, special deals, care tips and more!</p>
            <p className={brand?.code === 'PLA' ? 'plaBlock' : 'block'}>See <strong><a href="/privacy-policy" target="_blank" onClick={() => handleEventClick('Privacy Notice')}>Privacy Notice.</a></strong></p>
        </div>
    );
};

Subscription.propTypes = {
    classes: object.isRequired,
    jwt: string.isRequired,
};

const mapStateToProps = (state) => ({
    jwt: getAccessToken(state),
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps),
)(Subscription);
